import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faToggleOn } from '@fortawesome/pro-light-svg-icons'
import { faToggleOff } from '@fortawesome/pro-light-svg-icons'

import useSetState from 'hooks/useSetState'

import LoadingBubbles from 'components/LoadingBubbles'
import styles from './styles.scss'

const toggleSection = (props, setState) => {
  const { sectionId, toggleCallback } = props

  setState({ updating: true })
  toggleCallback(sectionId).then(() => {
    setState({ updating: false })
  })
}

const defaultState = {
  updating: false,
}

const ToggleableSection = (props) => {
  const { children, editing, enabled, title } = props

  const [state, setState] = useSetState(defaultState)
  const { updating } = state

  if (!editing && !enabled){
    return null
  }

  return (
    <section className={enabled ? styles.root : classnames(styles.root, styles.disabled)}>
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <h1>{title}</h1>

          {updating && (
            <span className={styles.toggle}>
              <LoadingBubbles />
            </span>
          )}

          {editing && (
            <a className={styles.toggle} tabIndex="0" onClick={() => toggleSection(props, setState)}>
              {enabled ? 'Enabled' : 'Disabled'}
              <FontAwesomeIcon icon={enabled ? faToggleOn : faToggleOff} className={styles.icon} />
            </a>
          )}
        </header>
        <main className={styles.content}>{children}</main>
      </div>
    </section>
  )
}

ToggleableSection.propTypes = {
  children: PropTypes.node.isRequired,
  editing: PropTypes.bool,
  enabled: PropTypes.bool,
  sectionId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  toggleCallback: PropTypes.func.isRequired,
}

ToggleableSection.defaultProps = {
  enabled: true,
  editing: false,
}

export default ToggleableSection
